import styled from 'styled-components';

export const TimeInputsRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: auto;
`;

export const TimeDropdownWrapper = styled('div')<{
  $popoverMinWidth?: number;
}>`
  position: relative;
  display: inline-flex;
  align-items: center;

  [role='listbox'] {
    ${({ $popoverMinWidth }) =>
      $popoverMinWidth !== undefined &&
      `
      min-width: ${$popoverMinWidth}px;
    `}
  }
`;
